/**
 * This is a wrapper around localStorage that allows us to either use
 * localStorage or store data in an internal structure. This is useful in cases
 * where the client doesn't support localStorage. Using a factory allows us to
 * test things more easily.
 */
export const webStorage = storage()

// creating this interface allows us to be able to mock localStorage
export interface storageProps {
  setItem?: (key: string, value: string) => void
  getItem?: (key: string) => string | null
  removeItem?: (key: string) => void
  clear?: () => void
}

// this factory function is split out from the export so that we can
// mock localStorage in our tests
export function storage(
  storage: storageProps = typeof window !== 'undefined'
    ? window.localStorage
    : {},
) {
  let data = {}
  let hasLocalStorage = false

  try {
    const x = 'storageTest'
    storage.setItem('x', x)
    storage.removeItem('x')
    hasLocalStorage = true
  } catch {
    hasLocalStorage = false
  }

  return {
    setItem: (key, value) => {
      if (hasLocalStorage) {
        storage.setItem(key, value)
      } else {
        data[key] = value
      }
    },

    getItem: key => {
      if (hasLocalStorage) {
        return storage.getItem(key)
      } else {
        return data[key]
      }
    },

    removeItem: key => {
      if (hasLocalStorage) {
        storage.removeItem(key)
      } else {
        delete data[key]
      }
    },

    clear: () => {
      if (hasLocalStorage) {
        storage.clear()
      } else {
        data = {}
      }
    },
  }
}
